import { PermissionsGuard } from './../../guards/permissions.guard'
import { PropertyPaymentsComponent } from './property-payments/property-payments.component'
import { PropertyDocumentsComponent } from './property-documents/property-documents.component'
import { PropertyComponent } from './property/property.component'
import { CreatePropertyComponent } from './create-property/create-property.component'
import { PropertyMeasureComponent } from './property-measure/property-measure.component'
import { PropertyContactsComponent } from './property-contacts/property-contacts.component'
import { PropertyGalleryComponent } from './property-gallery/property-gallery.component'
import { PropertyFeaturesComponent } from './property-features/property-features.component'
import { PropertyDetailsComponent } from './property-details/property-details.component'
import { PropertiesComponent } from './properties.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import {
  Routes,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'
import { PropertyHistoryComponent } from './property-history/property-history.component'

export function statusPermissions(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) {
  switch (route.params['type']) {
    case 'property_register':
      return 'STATUS_DATA_ENTRY'
    case 'data_entry':
      return 'STATUS_DATA_ENTRY'
    case 'assessment':
      return 'STATUS_ASSESSMENT'

    case 'billing':
      return 'STATUS_BILLING'

    case 'objection':
      return 'STATUS_OBJECTION'

    case 'archived':
      return 'STATUS_ARCHIVED'

    default:
      return ''
  }
}

export const propertiesRoutes: Routes = [
  {
    path: 'properties',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'PROPERTY_LIST',
        redirectTo: '/',
      },
    },
    children: [
      { path: '', redirectTo: 'property_register', pathMatch: 'full' },
      {
        path: 'create',
        component: CreatePropertyComponent,
        children: [
          { path: 'details', component: PropertyDetailsComponent },
          { path: 'features', component: PropertyFeaturesComponent },
          { path: 'contacts', component: PropertyContactsComponent },
          { path: 'measure', component: PropertyMeasureComponent },
          { path: 'gallery', component: PropertyGalleryComponent },
        ],
      },
      {
        path: ':type',
        component: PropertiesComponent,
        canActivate: [PermissionsGuard],
        data: {
          permissions: {
            only: statusPermissions,
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id',
        component: PropertyComponent,
        canActivate: [PermissionsGuard],
        children: [
          {
            path: 'details',
            component: PropertyDetailsComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: 'PROPERTY_TAB_DETAILS',
                redirectTo: '/',
              },
            },
          },
          {
            path: 'features',
            component: PropertyFeaturesComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: 'PROPERTY_TAB_FEATURES',
                redirectTo: '/',
              },
            },
          },
          {
            path: 'contacts',
            component: PropertyContactsComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: 'PROPERTY_TAB_CONTACTS',
                redirectTo: '/',
              },
            },
          },
          {
            path: 'measure',
            component: PropertyMeasureComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: 'PROPERTY_TAB_MEASURE',
                redirectTo: '/',
              },
            },
          },
          {
            path: 'gallery',
            component: PropertyGalleryComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: 'PROPERTY_TAB_GALLERY',
                redirectTo: '/',
              },
            },
          },
          {
            path: 'documents',
            component: PropertyDocumentsComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: 'PROPERTY_TAB_DOCUMENTS',
                redirectTo: '/',
              },
            },
          },
          {
            path: 'payments',
            component: PropertyPaymentsComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: 'PROPERTY_TAB_PAYMENTS',
                redirectTo: '/',
              },
            },
          },
          {
            path: 'history',
            component: PropertyHistoryComponent,
            canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: 'PROPERTY_TAB_PAYMENTS',
                redirectTo: '/',
              },
            },
          },
        ],
      },
    ],
  },
]
